import React from "react";
import { Zap, ShieldCheck, Wallet } from "lucide-react";

const PROPS = [
  {
    icon: Zap,
    num: "01",
    title: "Instant, No Back-and-Forth",
    description: "Book what you need in seconds — real-time availability, confirmed instantly. No calls. No waiting. No uncertainty.",
  },
  {
    icon: ShieldCheck,
    num: "02",
    title: "Zero-Risk Vendors",
    description: "We filter out the unreliable ones — so you never have to.",
  },
  {
    icon: Wallet,
    num: "03",
    title: "No Surprises. Ever.",
    description: "Upfront pricing, fully secured. What you book is exactly what you get.",
  },
];

export default function ValueProps() {
  return (
    <section data-testid="value-props-section" className="py-28 md:py-36 relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-16 lg:mb-24">
          <div className="text-sm tracking-wider uppercase font-semibold text-bhyyve-emerald mb-5">Why bHyyve?</div>
          <h2 className="font-heading text-5xl sm:text-6xl tracking-tight leading-[1.05] font-medium text-bhyyve-ink">
            Because your time shouldn't be wasted{" "}
            <span className="italic font-normal text-bhyyve-honeyDeep">chasing services.</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-7 lg:gap-10">
          {PROPS.map((prop, i) => (
            <div
              key={i}
              data-testid={`value-prop-card-${i}`}
              className="group relative flex flex-col gap-6 p-9 rounded-3xl bg-white border border-bhyyve-border/70 hover:border-bhyyve-honey/40 hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(122,79,0,0.22)] transition-all duration-500"
              style={{ animationDelay: `${i * 80}ms` }}
            >
              <div className="w-16 h-16 rounded-2xl bg-bhyyve-honey/[0.15] flex items-center justify-center group-hover:bg-bhyyve-charcoal transition-colors duration-500">
                <prop.icon className="w-7 h-7 text-bhyyve-honeyDeep group-hover:text-bhyyve-honey transition-colors duration-500" strokeWidth={1.75} aria-hidden="true" />
              </div>
              <div>
                <h3 className="font-heading text-2xl sm:text-3xl font-medium text-bhyyve-ink mb-3 tracking-tight">{prop.title}</h3>
                <p className="text-lg leading-relaxed text-bhyyve-muted">{prop.description}</p>
              </div>
              <div className="absolute top-7 right-7 text-sm font-mono text-bhyyve-muted/40">{prop.num}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
